import { Stand } from './stand.model';
import { RedeSocial } from "./rede-social.model";
import { Arquivo } from "./arquivo.model";
import { CategoriaSorteio } from "./categoria-sorteio.model";

export class Expositor {
    public Id: number;
    public SgunId: number;
    public Nome: string;
    public Logo: string;
    public LogoImage: any;
    public ListLogo: string;
    public Emblema: string;
    public Ttile: string;
    public Descricao: string;
    public LinkSite: String;
    public LinkSorteio: string;
    public LinkPesquisa: string;
    public LinkContato: string;
    public PrescritorPesquisa: boolean;
    public Tipo: string;
    public Destaque: boolean;
    public TemArquivos: boolean;
    public CongressoId: number;
    public CongressoAno: number;
    public Stand: Stand;
    public RedesSociais: Array<RedeSocial>;
    public Arquivos: Array<Arquivo>;
    public CategoriasSorteio: Array<CategoriaSorteio>;
}


// WEBPACK FOOTER //
// ./src/models/expositor/expositor.model.ts